<div class="empty-resul-component">
  <div class="d-flex flex-column no-profile justify-content-center align-items-center">
    <mat-icon [svgIcon]="icon" class="mb-2 empty-result-icon"></mat-icon>
    <span class="main-message">{{ message }}</span>
    <span *ngIf="complement" class="complement">{{ complement }}</span>
  </div>
</div>
